module.exports = __webpack_public_path__ + "static/img/8.2433989.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/sp/8.png
// module id = 5hYk
// module chunks = 0